export default {
  loading: 'Preparing a secure connection…',
  errorTitle: 'Unable to connect Trainn',
  returnToApp: 'Return to requesting app',
  introTitle: 'Connect {client} with {trainn}',
  benefits: {
    plan: {
      title: 'Create and Plan Courses',
      description: 'Build courses through chat.'
    },
    library: {
      title: 'Turn Recordings to Videos',
      description: 'Upload and let Trainn create videos.'
    },
    academy: {
      title: 'Talk to Your Content',
      description: 'Get answers about all your training.'
    }
  },
  signInTitle: 'Sign in to continue',
  signInDescription:
    'Sign in to connect {client}. You’ll choose a workspace and permissions in the next step.',
  signIn: 'Sign in and continue',
  accessPreviewTitle: '{client} can request access to:',
  accessPreview: {
    library: 'Find and use existing content, or upload new content.',
    academy: 'View, create, and manage courses and lessons.'
  },
  legalPrefix: 'By continuing, you agree to Trainn’s',
  terms: 'Terms of Service',
  legalAnd: 'and',
  privacy: 'Privacy Policy',
  connectTitle: '{client} wants to connect with Trainn',
  connectDescription:
    'Choose a workspace and decide what {client} can access and do.',
  workspaceTitle: 'Select a workspace',
  workspaceDescription: 'Choose a workspace. To switch later, disconnect and reconnect.',
  chooseWorkspace: 'Select a workspace',
  workspaceRole: 'Your role: {role}',
  reconnectWorkspace:
    'To switch workspaces later, disconnect {client} and reconnect it to another workspace.',
  noWorkspacesTitle: 'No eligible workspaces',
  noWorkspacesDescription:
    'You need an active Trainn workspace membership before you can approve this connection.',
  workspaceUnavailableTag: 'Unavailable',
  workspaceUnavailable: {
    mcp_not_enabled:
      'Trainn MCP is turned off for this workspace. Ask a workspace admin to enable it under Settings → Integrations → Trainn MCP, then connect again.',
    academy_not_enabled:
      'Academy is not available in this workspace. Choose another workspace or reconnect after Academy is enabled.',
    role_restricted: 'Your current Trainn role cannot grant every required permission for this workspace.',
    no_grantable_scopes: 'Your role or workspace policy does not allow the permissions requested by this app.'
  },
  permissionsTitle: 'Set permissions',
  permissionsDescription: 'Choose what {client} can do in this workspace.',
  resetDefaults: 'Reset to defaults',
  required: 'Required',
  noPermissionsTitle: 'No permissions available',
  noPermissionsDescription:
    'This workspace policy does not allow any of the permissions requested by this app.',
  selectWorkspaceFirst: 'Choose a workspace to continue',
  selectWorkspaceDescription:
    'Available permissions depend on your workspace policy and Trainn role.',
  protectedAccess: 'Your access stays protected',
  securityNotice:
    '{client} can access only the selected workspace. Your Trainn role and workspace policies continue to apply.',
  consentAgreement:
    'By selecting Allow access, you grant {client} the permissions selected above. You can disconnect it anytime.',
  unknownClient: 'This application',
  allow: 'Allow Access',
  verifiedTitle: 'Verified destination',
  verifiedDescription:
    'Return address verified by Trainn.',
  localTitle: 'Local app',
  localDescription:
    'This connection returns to an application on your device. Trainn cannot verify its publisher. Only continue if you started this connection.',
  unverifiedTitle: 'Unverified app',
  unverifiedDescription:
    'App not verified by Trainn.',
  unverifiedRedirectNotice: 'Authorizing will redirect you to {host}.',
  localRedirectNotice: 'Authorizing will return you to the app on your device.',
  missingRequest: 'The authorization request is missing or invalid.',
  expiredRequest: 'This authorization request has expired or is no longer available. Start the connection again from your MCP app.',
  browserMismatch: 'This browser could not verify the connection request. Sign in to Trainn in the browser where you started connecting, or enable cookies and start again from your MCP app.',
  sessionExpired: 'Your Trainn session has ended. Sign in again, then start the connection again from your MCP app.',
  accountMismatch:
    'Your sign-in does not match the account or workspace required for this connection. Sign in with the correct Trainn account and workspace, or start a new connection from your MCP app.',
  loadFailed: 'We could not load this connection request. Check your connection and try again.',
  consentFailed: 'We could not grant access. Review the workspace and permissions, then try again.',
  cancelFailed: 'We could not return to the requesting app. You can safely close this page.',
  scopeGroups: {
    library: {
      title: 'Library',
      description: 'Browse, upload, import, and inspect reusable learning content.'
    },
    academy: {
      title: 'Academy',
      description: 'View, create, and manage courses and their lessons.'
    }
  },
  scopes: {
    trainn: {
      content: {
        read: {
          title: 'View Content',
          description: 'Search and read videos, guides, articles, and documents in your Library.'
        },
        write: {
          title: 'Manage Content',
          description: 'Upload, import, create, edit, publish, and delete Library content.'
        }
      },
      course: {
        read: {
          title: 'View Courses',
          description: 'View courses, chapters, lessons, quizzes, settings, and preview links.'
        },
        draft: {
          title: 'Create and Manage Courses',
          description: 'Create, edit, delete, publish, and unpublish courses. Manage chapters, lessons, quizzes, settings, and attached content.'
        }
      }
    }
  }
};
